import { frWarnPalettes } from "../../../../Posts/02-tonos/12-paleta-calidos/warnPalettes.js";
import * as React from 'react';
export default {
  frWarnPalettes,
  React
};